<template>
<!-- 右侧内容 -->
  <section class="app-main" style="min-height: 100%">
    <transition>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
  }
}
</script>

<style lang="less" scoped>
.app-main {
  margin-left: 0.3rem;
  flex: 1;
  width: calc(100% - 1.9rem);
}
</style>